import { postWebHostOrderCalculatePrice, HostCalculatePriceResponse } from "api"
import { useEffect, useState } from "react"

type PriceParams = {
  hostResourceId: number | undefined
  startTime: string
  endTime: string
  selectedExtras: Record<number, number>
  couponCode?: string
}

export function useHostPrice({
  hostResourceId, startTime, endTime, selectedExtras, couponCode,
}: PriceParams) {
  const [priceData, setPriceData] = useState<HostCalculatePriceResponse | null>(null)
  const [loading, setLoading] = useState(false)

  const servicesKey = Object.entries(selectedExtras)
    .filter(([, qty]) => qty > 0)
    .map(([id, qty]) => `${id}:${qty}`)
    .join(",")

  useEffect(() => {
    if (!hostResourceId || !startTime || !endTime) {
      setPriceData(null)
      return
    }

    let cancelled = false
    setLoading(true)

    const services = Object.entries(selectedExtras)
      .filter(([, qty]) => qty > 0)
      .map(([id, qty]) => ({ id: Number(id), quantity: qty }))

    postWebHostOrderCalculatePrice({
      resource_id: hostResourceId,
      start_time: startTime,
      end_time: endTime,
      services,
      coupon_code: couponCode || "",
    })
      .then((res) => {
        if (!cancelled && res.data?.body) {
          setPriceData(res.data.body)
        }
      })
      .catch(() => {
        if (!cancelled) setPriceData(null)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hostResourceId, startTime, endTime, servicesKey, couponCode])

  return { priceData, loading }
}
